export interface HandshakeMetadata {
  userAgent: string;
  locale: string;
  referrer: string;
  queryParams: Record<string, string>;
  timestamp: string;
}

/**
 * Collects the client-side metadata for a checkout handshake: query params,
 * user agent, locale (locale query wins over navigator.language), and referrer.
 * IP is attached server-side by the event collector.
 */
export function collectHandshakeMetadata(
  win: Window = window,
): HandshakeMetadata {
  const params = new URLSearchParams(win.location.search);
  const queryParams: Record<string, string> = {};
  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  return {
    userAgent: win.navigator.userAgent ?? "",
    locale: params.get("locale") ?? win.navigator.language ?? "",
    referrer: win.document.referrer ?? "",
    queryParams,
    timestamp: new Date().toISOString(),
  };
}
